// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__13GXH","footer_title":"footer_footer_title__2lhSc"};